import { MdOutlineScreenSearchDesktop } from "react-icons/md";
import { BsPrinter } from "react-icons/bs";
import { CardLinkButton } from "../../components/CardLinkButton";
import { useAuth } from "../../hooks/auth";
import { permissions } from "../../shared/Permissions";

import * as S from "./styles";
import { useTranslation } from "react-i18next";

export function Inventory() {
  const { hasPermission } = useAuth();

  const { t } = useTranslation();

  const hasItemSearchPermission = hasPermission(
    permissions.inventory.itemSearch.view,
  );

  const hasAutoPrintPermission = hasPermission(
    permissions.inventory.autoPrint.view,
  );

  return (
    <S.InventoryContainer>
      <S.InventoryButtonContainer>
        {hasItemSearchPermission && (
          <CardLinkButton
            href="/inventory/item-search"
            title={t("itemSearch")}
            description={t("itemSearchDescription")}
          >
            <MdOutlineScreenSearchDesktop />
          </CardLinkButton>
        )}

        {hasAutoPrintPermission && (
          <CardLinkButton
            href="/inventory/auto-print"
            title={t("autoPrint")}
            description={t("autoPrintDescription")}
          >
            <BsPrinter />
          </CardLinkButton>
        )}
      </S.InventoryButtonContainer>
    </S.InventoryContainer>
  );
}
